"use client"
import { type FragmentOf, readFragment } from "@opensea/graphql"
import { Image } from "@opensea/next-ui-kit"
import ReactHlsPlayer from "react-hls-video-player"
import { getMediaPropsFromMedia } from "@/components/collection/overview/utils"
import { PreviewImageFragment } from "./PreviewImage.fragment"

type PreviewImageFragmentType = {
  media: FragmentOf<typeof PreviewImageFragment> | null
  thumbnailOnly?: boolean
}

export function PreviewImage({
  media: mediaKey,
  thumbnailOnly = false,
}: PreviewImageFragmentType) {
  const media = readFragment(PreviewImageFragment, mediaKey)
  const mediaProps = getMediaPropsFromMedia(media)

  function renderMediaComponent() {
    if (!mediaProps) {
      return null
    }

    if (
      thumbnailOnly &&
      (mediaProps.mediaType === "VideoMedia" ||
        mediaProps.mediaType === "MuxVideoMedia") &&
      mediaProps.thumbnailUrl
    ) {
      return (
        <Image
          alt=""
          layout="fill"
          objectFit="cover"
          objectPosition="center"
          src={mediaProps.thumbnailUrl}
        />
      )
    }

    switch (mediaProps.mediaType) {
      case "ImageMedia":
        return (
          <Image
            alt=""
            layout="fill"
            objectFit="cover"
            objectPosition="center"
            src={mediaProps.imageUrl}
          />
        )
      case "VideoMedia":
        return (
          <video
            autoPlay={!thumbnailOnly}
            className="size-full object-cover object-center"
            controls={false}
            loop
            muted
            playsInline
            poster={mediaProps.thumbnailUrl ?? undefined}
            src={mediaProps.videoUrl}
          />
        )
      case "MuxVideoMedia":
        return (
          <ReactHlsPlayer
            autoPlay={!thumbnailOnly}
            className="size-full object-cover object-center"
            controls={false}
            key={mediaProps.muxPlaybackId}
            loop
            muted
            playsInline
            poster={mediaProps.thumbnailUrl ?? undefined}
            src={`https://stream.mux.com/${mediaProps.muxPlaybackId}.m3u8`}
          />
        )
      default:
        return null
    }
  }

  return (
    <div className="relative aspect-square w-full overflow-hidden rounded-lg">
      {renderMediaComponent()}
    </div>
  )
}
